import React from "react";
import { UseGlobalState } from "../../state/gsh/gsh";

import { debugLog } from "../../util/debug";
import Auth from "../auth/Auth";


export default function TabHome() {
    const [state, setState] = UseGlobalState()

    React.useEffect(() => {
        debugLog('TabHome useEffect')
        if (!!state.tabQueryString) {
            state.tabQueryString = '';
            setState(state);
        }
      }, 
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [state]);

    return (
        <div className="App">
            <Auth destination="/tabdirect" tabView={true} />
        </div>
    )
}